import { render, staticRenderFns } from "./Checkbox.vue?vue&type=template&id=5bbaaf51&scoped=true"
import script from "./Checkbox.vue?vue&type=script&lang=ts"
export * from "./Checkbox.vue?vue&type=script&lang=ts"
import style0 from "./Checkbox.vue?vue&type=style&index=0&id=5bbaaf51&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbaaf51",
  null
  
)

export default component.exports